import type { Operator } from "@/src/types/components/operators/Operator";
import supabase from "$lib/services/db";
import { getOperator } from "./getOperator";

export async function getToplistOperators(
  tournamentToplist: number,
  isLive: boolean,
  maxOperators: number,
): Promise<(Operator | null)[]> {
  if (!isLive || !tournamentToplist) {
    console.error("Tournament is not live or no toplist ID provided");
    return [];
  }

  try {
    const { data, error } = await supabase.from("commercials").select("toplist").eq("id", tournamentToplist).single();

    if (error) throw error;

    const toplist = data.toplist.slice(0, maxOperators);

    const operatorPromises = toplist.map((sponsoredBy: number) => getOperator(sponsoredBy, isLive));
    return await Promise.all(operatorPromises);
  } catch (err) {
    console.error("Error fetching toplist operators:", (err as Error).message);
    return [];
  }
}
